// src/components/Footer.jsx - PROFESYONEL MOBİL FOOTER
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Phone, 
  Mail, 
  MapPin, 
  Linkedin, 
  Instagram, 
  Twitter,
  ShoppingBag,
  Heart,
  Tag,
  HelpCircle,
  FileText,
  Shield,
  Package,
  CreditCard,
  ChevronDown
} from 'lucide-react';
import jpglogo from '../assets/trona.jpg';

export default function Footer() {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  
  // Mobilde accordion için state
  const [openSections, setOpenSections] = useState({
    links: false,
    services: false,
    contact: false
  });

  const toggleSection = (section) => {
    setOpenSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  return (
    <footer className="footer">
      <Style />
      <div className="container">
        <div className="footer-content">
          {/* Logo ve Hakkında Bölümü - Her zaman görünür */}
          <div className="footer-col brand-col">
            <div className="footer-logo" onClick={() => navigate('/')}>
              <img src={jpglogo} alt="Trona Pazarlama" />
            </div>
            <p className="brand-description">
              Kaliteli ürünler, uygun fiyatlar ve hızlı teslimat.
            </p>
            <div className="social-links-footer">
              <a 
                href="https://www.linkedin.com/in/%C3%B6mer-%C5%9Fahin-4a5355234/" 
                target="_blank" 
                rel="noreferrer"
                className="social-link linkedin"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>
              <a 
                href="https://instagram.com/tronapazarlama" 
                target="_blank" 
                rel="noreferrer"
                className="social-link instagram"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a 
                href="#" 
                className="social-link twitter"
                aria-label="Twitter"
              >
                <Twitter size={18} />
              </a>
            </div>
          </div>

          {/* Hızlı Linkler - Desktop'ta açık, mobilde accordion */}
          <div className="footer-col desktop-only">
            <h4>Hızlı Linkler</h4>
            <ul>
              <li><a href="/campaigns"><Tag size={14} />Kampanyalar</a></li>
              <li><a href="/wishlist"><Heart size={14} />Favorilerim</a></li>
              <li><a href="/search"><ShoppingBag size={14} />Tüm Ürünler</a></li>
              <li><a href="/contact"><HelpCircle size={14} />İletişim</a></li>
            </ul>
          </div>

          {/* Müşteri Hizmetleri - Desktop'ta açık, mobilde accordion */}
          <div className="footer-col desktop-only">
            <h4>Müşteri Hizmetleri</h4>
            <ul>
              <li><a href="/faq"><HelpCircle size={14} />S.S.S</a></li>
              <li><a href="/shipping"><Package size={14} />Teslimat</a></li>
              <li><a href="/returns"><FileText size={14} />İade</a></li>
              <li><a href="/payment"><CreditCard size={14} />Ödeme</a></li>
            </ul>
          </div>

          {/* İletişim - Desktop'ta açık, mobilde accordion */}
          <div className="footer-col contact-col desktop-only">
            <h4>İletişim</h4>
            <ul className="contact-list">
              <li>
                <div className="contact-item-footer">
                  <div className="contact-icon"><Phone size={14} /></div>
                  <div className="contact-info-footer">
                    <a href="tel:05356434181">0535 643 41 81</a>
                  </div>
                </div>
              </li>
              <li>
                <div className="contact-item-footer">
                  <div className="contact-icon"><Mail size={14} /></div>
                  <div className="contact-info-footer">
                    <a href="mailto:info@tronapazarlama.com">info@tronapazarlama.com</a>
                  </div>
                </div>
              </li>
              <li>
                <div className="contact-item-footer">
                  <div className="contact-icon"><MapPin size={14} /></div>
                  <div className="contact-info-footer">
                    <span>Manavgat, Antalya, Türkiye</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          {/* MOBİL ACCORDION MENÜLER */}
          <div className="mobile-accordion">
            {/* Hızlı Linkler Accordion */}
            <div className="accordion-item">
              <button 
                className="accordion-header"
                onClick={() => toggleSection('links')}
              >
                <span>Hızlı Linkler</span>
                <ChevronDown 
                  size={16} 
                  className={`chevron ${openSections.links ? 'open' : ''}`}
                />
              </button>
              <div className={`accordion-content ${openSections.links ? 'open' : ''}`}>
                <ul>
                  <li><a href="/campaigns">Kampanyalar</a></li>
                  <li><a href="/wishlist">Favorilerim</a></li>
                  <li><a href="/search">Tüm Ürünler</a></li>
                  <li><a href="/contact">İletişim</a></li>
                </ul>
              </div>
            </div>

            {/* Müşteri Hizmetleri Accordion */}
            <div className="accordion-item">
              <button 
                className="accordion-header"
                onClick={() => toggleSection('services')}
              >
                <span>Müşteri Hizmetleri</span>
                <ChevronDown 
                  size={16} 
                  className={`chevron ${openSections.services ? 'open' : ''}`}
                />
              </button>
              <div className={`accordion-content ${openSections.services ? 'open' : ''}`}>
                <ul>
                  <li><a href="/faq">S.S.S</a></li>
                  <li><a href="/shipping">Teslimat</a></li>
                  <li><a href="/returns">İade ve Değişim</a></li>
                  <li><a href="/payment">Ödeme</a></li>
                </ul>
              </div>
            </div>

            {/* İletişim Accordion */}
            <div className="accordion-item">
              <button 
                className="accordion-header"
                onClick={() => toggleSection('contact')}
              >
                <span>İletişim</span>
                <ChevronDown 
                  size={16} 
                  className={`chevron ${openSections.contact ? 'open' : ''}`}
                />
              </button>
              <div className={`accordion-content ${openSections.contact ? 'open' : ''}`}>
                <ul className="contact-list-mobile">
                  <li><a href="tel:05356434181">0535 643 41 81</a></li>
                  <li><a href="mailto:info@tronapazarlama.com">info@tronapazarlama.com</a></li>
                  <li><span>Manavgat, Antalya, Türkiye</span></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Alt Bölüm */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">© {currentYear} Tronapazarlama</p>
            <div className="footer-links">
              <a href="/privacy" className="footer-link">Gizlilik</a>
              <span className="separator">•</span>
              <a href="/terms" className="footer-link">Koşullar</a>
              <span className="separator">•</span>
              <a href="/cookies" className="footer-link">Çerezler</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

function Style() {
  return (
    <style>{`
      .footer {
        background: #2B2B2B;
        color: #fff;
        padding: 48px 0 0;
        margin-top: auto;
      }

      .footer .container {
        max-width: 1320px;
        margin: 0 auto;
        padding: 0 20px;
      }

      /* Footer Content */
      .footer-content {
        display: grid;
        grid-template-columns: 2fr 1fr 1fr 1.2fr;
        gap: 40px;
        padding-bottom: 40px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      }

      .footer-col {
        display: flex;
        flex-direction: column;
      }

      /* Brand Column */
      .brand-col {
        max-width: 380px;
      }

      .footer-logo {
        width: 100px;
        height: 100px;
        background: #fff;
        border-radius: 14px;
        padding: 10px;
        margin-bottom: 16px;
        cursor: pointer;
        transition: all 0.3s;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }

      .footer-logo:hover {
        transform: translateY(-3px);
        box-shadow: 0 6px 20px rgba(229, 51, 42, 0.25);
      }

      .footer-logo img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }

      .brand-description {
        color: rgba(255, 255, 255, 0.65);
        line-height: 1.6;
        margin-bottom: 20px;
        font-size: 13px;
      }

      /* Social Links */
      .social-links-footer {
        display: flex;
        gap: 10px;
      }

      .social-link {
        width: 38px;
        height: 38px;
        background: rgba(255, 255, 255, 0.08);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        transition: all 0.3s;
        text-decoration: none;
      }

      .social-link:hover {
        transform: translateY(-3px);
        box-shadow: 0 4px 12px rgba(255, 255, 255, 0.15);
      }

      .social-link.linkedin:hover {
        background: #0077B5;
      }

      .social-link.instagram:hover {
        background: linear-gradient(135deg, #E4405F, #C13584);
      }

      .social-link.twitter:hover {
        background: #1DA1F2;
      }

      /* Footer Columns */
      .footer-col h4 {
        font-size: 15px;
        font-weight: 700;
        margin-bottom: 16px;
        color: #fff;
        letter-spacing: 0.3px;
      }

      .footer-col ul {
        list-style: none;
        display: flex;
        flex-direction: column;
        gap: 10px;
      }

      .footer-col ul li a {
        color: rgba(255, 255, 255, 0.65);
        text-decoration: none;
        transition: all 0.2s;
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
        padding: 2px 0;
      }

      .footer-col ul li a:hover {
        color: #E5332A;
        transform: translateX(3px);
      }

      .footer-col ul li a svg {
        flex-shrink: 0;
        opacity: 0.6;
      }

      /* Contact List */
      .contact-list {
        gap: 12px;
      }

      .contact-item-footer {
        display: flex;
        align-items: center;
        gap: 10px;
      }

      .contact-icon {
        width: 32px;
        height: 32px;
        background: rgba(229, 51, 42, 0.1);
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #E5332A;
        flex-shrink: 0;
      }

      .contact-info-footer {
        display: flex;
        flex-direction: column;
        gap: 2px;
      }

      .contact-info-footer a,
      .contact-info-footer span {
        color: rgba(255, 255, 255, 0.7);
        text-decoration: none;
        font-size: 13px;
        transition: color 0.2s;
      }

      .contact-info-footer a:hover {
        color: #E5332A;
      }

      /* MOBİL ACCORDION - Varsayılan gizli */
      .mobile-accordion {
        display: none;
        width: 100%;
        grid-column: 1 / -1;
      }

      .accordion-item {
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      }

      .accordion-header {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 0;
        background: none;
        border: none;
        color: #fff;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s;
      }

      .accordion-header:active {
        opacity: 0.7;
      }

      .chevron {
        transition: transform 0.3s ease;
        color: rgba(255, 255, 255, 0.5);
      }

      .chevron.open {
        transform: rotate(180deg);
      }

      .accordion-content {
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.3s ease;
      }

      .accordion-content.open {
        max-height: 300px;
        padding-bottom: 12px;
      }

      .accordion-content ul {
        list-style: none;
        display: flex;
        flex-direction: column;
        gap: 10px;
      }

      .accordion-content ul li a,
      .accordion-content ul li span {
        color: rgba(255, 255, 255, 0.6);
        text-decoration: none;
        font-size: 13px;
        display: block;
        padding: 4px 0;
        transition: color 0.2s;
      }

      .accordion-content ul li a:hover {
        color: #E5332A;
      }

      .contact-list-mobile {
        gap: 8px;
      }

      /* Footer Bottom */
      .footer-bottom {
        padding: 20px 0;
      }

      .footer-bottom-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 12px;
      }

      .copyright {
        color: rgba(255, 255, 255, 0.45);
        font-size: 13px;
        margin: 0;
      }

      .footer-links {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-wrap: wrap;
      }

      .footer-link {
        color: rgba(255, 255, 255, 0.55);
        text-decoration: none;
        font-size: 12px;
        transition: color 0.2s;
      }

      .footer-link:hover {
        color: #E5332A;
      }

      .separator {
        color: rgba(255, 255, 255, 0.25);
        font-size: 10px;
      }

      /* ============================================
         📱 MOBİL RESPONSIVE
         ============================================ */

      /* Tablet - 992px */
      @media (max-width: 992px) {
        .footer {
          padding: 40px 0 0;
        }

        .footer-content {
          grid-template-columns: repeat(2, 1fr);
          gap: 32px;
          padding-bottom: 32px;
        }

        .brand-col {
          grid-column: 1 / -1;
          max-width: 100%;
        }
      }

      /* Mobil - 768px: MİNİMALİST TASARIM */
      @media (max-width: 768px) {
        .footer {
          padding: 28px 0 0;
        }

        .footer-content {
          grid-template-columns: 1fr;
          gap: 20px;
          padding-bottom: 24px;
        }

        /* Desktop kolonları gizle */
        .desktop-only {
          display: none !important;
        }

        /* Mobil accordion göster */
        .mobile-accordion {
          display: block !important;
        }

        .brand-col {
          text-align: center;
          align-items: center;
        }

        .footer-logo {
          width: 70px;
          height: 70px;
          margin: 0 auto 12px;
          border-radius: 12px;
        }

        .brand-description {
          font-size: 12px;
          margin-bottom: 16px;
          max-width: 280px;
        }

        .social-links-footer {
          justify-content: center;
          gap: 8px;
        }

        .social-link {
          width: 36px;
          height: 36px;
        }

        .social-link svg {
          width: 16px;
          height: 16px;
        }

        .footer-bottom {
          padding: 16px 0;
        }

        .footer-bottom-content {
          flex-direction: column;
          gap: 10px;
          text-align: center;
        }

        .copyright {
          font-size: 11px;
        }

        .footer-links {
          justify-content: center;
          gap: 8px;
        }

        .footer-link {
          font-size: 11px;
        }
      }

      /* Küçük Mobil - 480px */
      @media (max-width: 480px) {
        .footer {
          padding: 24px 0 0;
        }

        .footer .container {
          padding: 0 16px;
        }

        .footer-content {
          gap: 16px;
          padding-bottom: 20px;
        }

        .footer-logo {
          width: 60px;
          height: 60px;
        }

        .brand-description {
          font-size: 11px;
          line-height: 1.5;
          margin-bottom: 12px;
        }

        .social-link {
          width: 32px;
          height: 32px;
        }

        .social-link svg {
          width: 14px;
          height: 14px;
        }

        .accordion-header {
          padding: 12px 0;
          font-size: 13px;
        }

        .accordion-content ul li a,
        .accordion-content ul li span {
          font-size: 12px;
        }

        .footer-bottom {
          padding: 14px 0;
        }

        .copyright {
          font-size: 10px;
        }

        .footer-link {
          font-size: 10px;
        }
      }

      /* Çok Küçük Ekranlar - 360px */
      @media (max-width: 360px) {
        .footer .container {
          padding: 0 12px;
        }

        .footer-logo {
          width: 50px;
          height: 50px;
        }

        .brand-description {
          font-size: 10px;
        }

        .accordion-header {
          font-size: 12px;
        }
      }
    `}</style>
  );
}